import { api } from '../api';
import type { Export } from '../types';

/* istanbul ignore file */

export const exportApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    exportApplication: builder.query<Export, { id: string }>({
      query: ({ id }) => `api/export/application/${id}/`,
    }),
    exportAccount: builder.query<Export, { id: string }>({
      query: ({ id }) => `api/export/account/${id}`,
    }),
  }),
});
